export default __webpack_public_path__ + "static/media/qrcode.9b359b73.svg";